// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__U6dUp","container":"styles_container__11jb4","title":"styles_title__3metL","wrapper":"styles_wrapper__ODQ6M","answer":"styles_answer__1PC5P"};